import { useEffect, useState } from "react";
import axios from "axios";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const EventPopup = () => {
  const [banner, setBanner] = useState(null);
  const [open, setOpen] = useState(false); // ❗ start CLOSED

  useEffect(() => {
  const fetchBanner = async () => {
    try {
      const res = await axios.get("https://ashokahospitalhubli.com/api/banner");

      if (res.data?.image) {
        setBanner(res.data);
        setOpen(true);
      } else {
        setBanner(null);
        setOpen(false);
      }
    } catch {
      setBanner(null);
      setOpen(false);
    }
  };

  fetchBanner();
}, []);

  if (!open || !banner?.image) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 bg-black/70 flex justify-center pt-24 px-4"
      >
        <motion.div
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          className="relative bg-white rounded-2xl overflow-hidden max-w-lg w-full"
        >
          <img
            src={`https://ashokahospitalhubli.com${banner.image}`}
            className="w-full object-cover"
          />

          <button
            onClick={() => setOpen(false)}
            className="absolute top-3 right-3 bg-black/60 text-white p-2 rounded-full"
          >
            <X size={20} />
          </button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default EventPopup;
